// extracted by mini-css-extract-plugin
export var button = "_9o-0";
export var icon = "_9o-1";